if (!window.__shUpcartWarranty) {
  window.__shUpcartWarranty = true;

  const cache = new Map();
  let running = false;
  let queued = false;
  let refreshTimers = [];

  const QTY_SELECTOR = [
    '.upcart-public-component-product-tile__quantity-minus',
    '.upcart-public-component-product-tile__quantity-plus',
    '.cv-qty__input',
    '.upcart-product-quantity-minus',
    '.upcart-product-quantity-plus',
    '.upcart-product-quantity-input',
    '.styles_quantityMinus__',
    '.styles_quantityPlus__',
    '.styles_quantityInput__'
  ].join(',');

  const ITEM_SELECTOR = '.upcart-product-item, .upcart-public-component-product-tile';

  const cartRoot = () => {
    const host = document.querySelector('#upCart');
    if (!host) return null;

    const shadow = host.shadowRoot;
    if (shadow && shadow.querySelector(ITEM_SELECTOR)) return shadow;
    if (host.querySelector(ITEM_SELECTOR)) return host;
    return shadow || host;
  };

  const productPath = (handle) => {
    const routes = window.Shopify && window.Shopify.routes;
    const root = routes && routes.root ? routes.root : '/';
    const base = root.endsWith('/') ? root : root + '/';
    return base + 'products/' + encodeURIComponent(handle) + '?sections=sh-upcart-warranty';
  };

  const loadWarranty = (handle) => {
    if (!cache.has(handle)) {
      cache.set(
        handle,
        fetch(productPath(handle), { credentials: 'same-origin' })
          .then((response) => (response.ok ? response.json() : null))
          .then((payload) => {
            const html = payload && payload['sh-upcart-warranty'];
            if (!html) return null;
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const node = doc.querySelector('[data-sh-upcart-warranty]');
            if (!node || node.dataset.show !== '1' || !node.dataset.label) return null;
            return {
              label: node.dataset.label,
              icon: node.dataset.icon || ''
            };
          })
          .catch(() => null)
      );
    }
    return cache.get(handle);
  };

  const handleFromItem = (item) => {
    const link = item.querySelector('a[href*="/products/"]');
    if (!link) return '';
    const match = (link.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  };

  const anchorFor = (item) =>
    item.querySelector('.upcart-item-option') ||
    item.querySelector('.upcart-public-component-product-tile__variant') ||
    item.querySelector('.upcart-product-title') ||
    item.querySelector('.upcart-public-component-product-tile__product-title');

  const renderRow = (data) => {
    const row = document.createElement('p');
    row.className = 'sh-upcart-warranty';
    row.dataset.label = data.label;
    row.dataset.icon = data.icon;

    if (data.icon) {
      const icon = document.createElement('span');
      icon.className = 'sh-upcart-warranty__icon';
      icon.style.setProperty('--sh-warranty-icon', 'url("' + data.icon.replace(/"/g, '') + '")');
      icon.setAttribute('aria-hidden', 'true');
      row.appendChild(icon);
    }

    const text = document.createElement('span');
    text.textContent = data.label;
    row.appendChild(text);
    return row;
  };

  const applyItem = (item, data) => {
    const existing = item.querySelector('.sh-upcart-warranty');
    if (!data) {
      if (existing) existing.remove();
      return;
    }
    if (existing && existing.dataset.label === data.label && existing.dataset.icon === data.icon) return;
    if (existing) existing.remove();

    const anchor = anchorFor(item);
    if (!anchor) return;
    anchor.insertAdjacentElement('afterend', renderRow(data));
  };

  const itemNodes = (root) => [...root.querySelectorAll(ITEM_SELECTOR)];

  const attachStylesheet = (root) => {
    if (!root || root.nodeType !== Node.DOCUMENT_FRAGMENT_NODE) return;
    if (root.querySelector('link[data-sh-upcart-warranty-css]')) return;
    const source = document.querySelector('link[href*="apps.css"]');
    if (!source) return;
    const link = source.cloneNode();
    link.media = 'all';
    link.setAttribute('data-sh-upcart-warranty-css', '');
    root.appendChild(link);
  };

  const paint = async () => {
    const root = cartRoot();
    if (!root) return;
    if (running) {
      queued = true;
      return;
    }

    running = true;
    try {
      attachStylesheet(root);
      const handles = [...new Set(itemNodes(root).map(handleFromItem).filter(Boolean))];
      const dataByHandle = new Map();
      await Promise.all(
        handles.map(async (handle) => {
          dataByHandle.set(handle, await loadWarranty(handle));
        })
      );

      const currentRoot = cartRoot();
      if (!currentRoot) return;
      attachStylesheet(currentRoot);
      itemNodes(currentRoot).forEach((item) => {
        const handle = handleFromItem(item);
        applyItem(item, handle ? dataByHandle.get(handle) || null : null);
      });
    } finally {
      running = false;
      if (queued) {
        queued = false;
        paint();
      }
    }
  };

  const refresh = () => {
    refreshTimers.forEach((id) => window.clearTimeout(id));
    refreshTimers = [0, 150, 450].map((delay) => window.setTimeout(paint, delay));
  };

  const onQuantityChange = (event) => {
    const path = typeof event.composedPath === 'function' ? event.composedPath() : [];
    const hit = path.some((node) => node.matches && node.matches(QTY_SELECTOR));
    if (hit) refresh();
  };

  const bind = () => {
    if (window.__shUpcartWarrantyBound) return true;
    if (typeof window.upcartSubscribeCartLoaded !== 'function') return false;

    window.upcartSubscribeCartLoaded(refresh);
    if (typeof window.upcartSubscribeCartUpdated === 'function') window.upcartSubscribeCartUpdated(refresh);
    if (typeof window.upcartSubscribeCartOpened === 'function') window.upcartSubscribeCartOpened(refresh);
    if (typeof window.upcartSubscribeAddedToCart === 'function') window.upcartSubscribeAddedToCart(refresh);
    if (typeof window.upcartSubscribeItemRemoved === 'function') window.upcartSubscribeItemRemoved(refresh);

    document.addEventListener('click', onQuantityChange, true);
    document.addEventListener('change', onQuantityChange, true);

    window.__shUpcartWarrantyBound = true;
    refresh();
    return true;
  };

  if (!bind()) {
    const timer = window.setInterval(() => {
      if (bind()) window.clearInterval(timer);
    }, 250);
    window.setTimeout(() => window.clearInterval(timer), 20000);
  }
}
